/* Size the visible artwork, rather than transparent padding in its source file. */
(() => {
  if (window.akSimpleRelatedFitBound) return;
  window.akSimpleRelatedFitBound = true;
  const cache = new Map();
  const bound = new WeakSet();
  const resize = new ResizeObserver(entries => entries.forEach(entry => {
    const image=entry.target.querySelector('.ak-simple-related-product-image');
    if(image)fit(image);
  }));
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d', {willReadFrequently: true});

  function fit(image) {
    if (!image.naturalWidth || !image.naturalHeight) return;
    // Keep one measurement when the browser upgrades a responsive source.
    const source = image.src || image.currentSrc;
    let bounds = cache.get(source);
    if (!bounds) {
      bounds = {width: 1, height: 1, x: 0, y: 0};
      try {
        const scale = Math.min(1, 512 / Math.max(image.naturalWidth, image.naturalHeight));
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        let left = canvas.width, right = -1, top = canvas.height, bottom = -1;
        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            if (pixels[(y * canvas.width + x) * 4 + 3] <= 16) continue;
            left = Math.min(left, x);
            right = Math.max(right, x);
            top = Math.min(top, y);
            bottom = Math.max(bottom, y);
          }
        }
        if (right >= left && bottom >= top) {
          bounds = {
            width: (right - left + 1) / canvas.width,
            height: (bottom - top + 1) / canvas.height,
            x: (.5 - (left + right + 1) / (2 * canvas.width)) * 100,
            y: (.5 - (top + bottom + 1) / (2 * canvas.height)) * 100
          };
        }
      } catch (error) {
        // An unreadable external image still gets the normal 80% fallback.
      }
      cache.set(source, bounds);
    }
    const visual=image.closest('.ak-session-6__visual');
    if(!visual?.clientWidth || !visual.clientHeight)return;
    const fraction=image.closest('a')?.getAttribute('href')?.includes('/products/kingpong-') ? .65 : .8;
    const scale=Math.min(
      visual.clientWidth*fraction/(image.naturalWidth*bounds.width),
      visual.clientHeight*fraction/(image.naturalHeight*bounds.height)
    );
    image.style.setProperty('--ak-related-art-width', `${image.naturalWidth*scale}px`);
    image.style.setProperty('--ak-related-art-height', `${image.naturalHeight*scale}px`);
    image.style.setProperty('--ak-related-visible-height', bounds.height);
    image.style.setProperty('--ak-related-art-x', `${bounds.x}%`);
    image.style.setProperty('--ak-related-art-y', `${bounds.y}%`);
    image.setAttribute('data-ak-related-art-ready', '');
  }

  function init() {
    document.querySelectorAll('.ak-simple-related-image-frame .ak-simple-related-product-image').forEach(image => {
      if (bound.has(image)) return;
      bound.add(image);
      image.addEventListener('load', () => fit(image));
      const visual=image.closest('.ak-session-6__visual');
      if(visual)resize.observe(visual);
      if (image.complete) fit(image);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
